import * as d3 from "d3";
import queryString from "query-string";

// Store everything in queryString, get it from there
const query = queryString.parse(window.location.href.split("?")[1] || "");

const availableModes = [
  "blend pyramid",
  "blend horizontal",
  "no blend pyramid",
  "no blend horizontal"
];

const imageFlipper = {
  state: {
    availableModes: availableModes,
    mode:
      query.m && availableModes.indexOf(query.m) >= 0
        ? query.m
        : "blend pyramid",
    blendPercentage: query.blend ? query.blend : 0.09,
    visibleDistance: query.visibleDistance ? query.visibleDistance : 0.02,
    bottomScale: null,
    topScale: null
  },

  mutations: {
    setBlendPercentage(state, { blendPercentage }) {
      state.blendPercentage = blendPercentage;
    },

    setBottomScale(state, { bottomScale }) {
      state.bottomScale = bottomScale;
    },

    setImageFlipperMode(state, { mode }) {
      state.mode = mode;
    },

    setTopScale(state, { topScale }) {
      state.topScale = topScale;
    },

    setVisibleDistance(state, { visibleDistance }) {
      state.visibleDistance = visibleDistance;
    }
  },

  actions: {
    setBlendPercentage({ commit }, blendPercentage) {
      commit("setBlendPercentage", {
        blendPercentage,
        pushToURL: { blend: blendPercentage }
      });
    },

    setBottomScale({ commit }, bottomScale) {
      commit("setBottomScale", { bottomScale });
    },

    setImageFlipperMode({ commit, state }, mode) {
      if (state.availableModes.indexOf(mode) < 0) return;
      commit("setImageFlipperMode", {
        mode,
        pushToURL: { m: mode }
      });
    },

    setTopScale({ commit }, topScale) {
      commit("setTopScale", { topScale });
    },

    setVisibleDistance({ commit, state }, visibleDistance) {
      if (state.visibleDistance !== visibleDistance) {
        commit("setVisibleDistance", {
          visibleDistance,
          pushToURL: { visibleDistance }
        });
      }
    }
  },

  getters: {
    getScale: state => (width, height) => {
      const aspectRatio = width / height;

      return d3
        .scaleLinear()
        .domain([
          aspectRatio * (state.visibleDistance / 2),
          aspectRatio * -(state.visibleDistance / 2)
        ])
        .range([0, width]);
    }
  }
};

export default imageFlipper;
